import { render, staticRenderFns } from "./select-card.vue?vue&type=template&id=5be7ea80&scoped=true"
import script from "./select-card.vue?vue&type=script&lang=ts"
export * from "./select-card.vue?vue&type=script&lang=ts"
import style0 from "./select-card.vue?vue&type=style&index=0&id=5be7ea80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be7ea80",
  null
  
)

export default component.exports